'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: '3002',
  apiUrl: process.env.APIURL || 'http://api.dev.jai20enmaths.com:8000/v1',
  storefront: {
    staticUrl: 'https://cdn.jai20enphysique.com',
    documentsImagesPath: 'd'
  },
  app: {
    title: 'CMS Jai20enmaths',
    head: {
      titleTemplate: 'CMS Jai20enmaths',
      meta: [{ name: 'robots', content: 'noindex' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 1166
// module chunks = 0